import api from './api';
class SmartSearchService {
    searchByString(searchString) {
        return api.get('/smart_search/by?searchString='+searchString);
    }

}
export default new SmartSearchService();